import React, { useMemo, useState, useEffect, useCallback } from 'react';
// import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import {
  TextField,
  Button,
  LinearProgress,
  Grid,
  MenuItem,
} from '@material-ui/core';
import { LocalGasStation, Waves } from '@material-ui/icons';
import { Autocomplete } from '@material-ui/lab';
import { format } from 'date-fns';
import { isNull, isArray } from 'lodash';

import { t, dataHora, hora } from '~/helpers';
import api from '~/services/api';

import { Tabela } from './components';
import AbastecimentoPitStop from './components/Atendimento/Abastecimento';
import LubrificacaoPitStop from './components/Atendimento/Lubrificacao';

const delayRefresh = 5;

function Checkliberadoparaintegracao() {
  const [load, setLoad] = React.useState(false);

  const [params, setParams] = useState({
    datahorainicialmovimentacao: format(new Date(), 'yyyy-MM-dd 00:00:00'),
    datahorafinalmovimentacao: format(new Date(), 'yyyy-MM-dd 23:59:59'),
    idposto: '',
    idveiculo: '',
    codigoatendimento: '',
    status: '',
  });

  // const options = useMemo(
  //   () => [
  //     { value: '1', label: t('s.geral.opcoes.pendente') },
  //     { value: '3', label: t('s.geral.opcoes.naoaprovado') },
  //   ],
  //   []
  // );

  const [loading, setLoading] = useState(false);
  const [postos, setPostos] = React.useState([]);
  const [idpostoGlobal, setIdPostoGlobal] = React.useState(null);
  const [idturno, setIdturno] = React.useState(null);
  const [slapitstopposto, setSlapitstopposto] = React.useState(null);
  const [datahorainicialturno, setDatahorainicialturno] = React.useState(null);
  const [datahorafinalturno, setDatahorafinalturno] = React.useState(null);
  const [atendimentos, setAtendimentos] = React.useState([]);
  const [posto, setPosto] = React.useState(null);

  //

  // const data = useSelector((state) => state.pitStop);
  // const token = useSelector((state) => state.auth);

  // forms

  const exibirAbastecimentoPitStopRef = React.useRef(null);
  const exibirLubrificacaoPitStopRef = React.useRef(null);

  // const [parametros, setParametros] = React.useState(null);
  const [viewAtendimentos, setViewAtendimentos] = React.useState(true);
  const [viewAbastecimentos, setViewAbastecimentos] = React.useState(false);
  //
  const [janelaAberta, setJanelaAberta] = React.useState(false);

  const handleUpdate = (result) => {
    fetchData();
    setJanelaAberta(false);
  };

  const handleClose = () => {
    setJanelaAberta(false);
  };

  const execucao = useMemo(
    () => [
      { label: '0', value: '' },
      { label: 'N', value: t('s.geral.opcoes.nao') },
      { label: 'S', value: t('s.geral.opcoes.sim') },
      { label: 'X', value: t('s.geral.opcoes.na') },
    ],
    []
  );

  const headerAtendimento = useMemo(
    () => [
      {
        id: 'codigonomeposto',
        label: t('s.operacao.abastecimento.nomeposto'),
        align: 'left',
      },
      {
        id: 'codigoatendimento',
        label: t('s.cadastro.pitstop.codigoatendimento'),
        align: 'left',
      },
      {
        id: 'dataencosteatendimento',
        label: t('s.cadastro.pitstop.dataencosteatendimento'),
        format: (value) => dataHora(value),
      },
      {
        id: 'dataliberacaoatendimento',
        label: t('s.cadastro.pitstop.dataliberacaoatendimento'),
        align: 'left',
        format: (value) => hora(value),
      },
      {
        id: 'idveiculo',
        label: t('s.menu.cadastro.veiculo.locomotiva'),
      },
      {
        id: 'nomeusuarioresponsavel',
        label: t('s.cadastro.pitstop.nomeusuarioresponsavel'),
      },
      {
        id: 'statuslibintegraatendimentoabastecimento',
        label: t('s.cadastro.pitstop.abastecimento'),
        format: (value) => execucao.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: execucao },
        styledIcon: (value) =>
          value === 0
            ? {
                // marginLeft: value ? 8 : 0,
                marginLeft: 8,
                cursor: 'pointer',
                color: '#00B300',
              }
            : value === 1
            ? {
                marginLeft: 8,
                cursor: 'pointer',
                color: '#ffbf00',
              }
            : value === 2
            ? {
                marginLeft: 8,
                cursor: 'pointer',
                color: '#00B300',
              }
            : value === 4
            ? {
                marginLeft: 8,
                cursor: 'pointer',
                color: '#005cb3ff',
              }
            : {
                marginLeft: 8,
                cursor: 'pointer',
                color: '#ff0000',
              },
        action: [
          {
            label: t('s.cadastro.pitstop.abastecimento'),
            botao: LocalGasStation,
            edicao: 'abastecimento',
            origem: 'A',
          },
        ],
      },
      {
        id: 'statuslibintegraatendimentolubrificacao',
        label: t('s.cadastro.pitstop.lubrificacao'),
        format: (value) => execucao.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: execucao },
        styledIcon: (value) =>
          value === 0
            ? {
                marginLeft: 8,
                cursor: 'pointer',
                color: '#00B300',
              }
            : value === 1
            ? {
                marginLeft: 8,
                cursor: 'pointer',
                color: '#ffbf00',
                // color: '#ff0000',
              }
            : value === 2
            ? {
                marginLeft: 8,
                cursor: 'pointer',
                color: '#00B300',
                // color: '#ffbf00',
              }
            : value === 4
            ? {
                marginLeft: 8,
                cursor: 'pointer',
                color: '#005cb3ff',
              }
            : {
                marginLeft: 8,
                cursor: 'pointer',
                color: '#ff0000',
                // color: '#999999',
              },
        // styledIcon: (value) =>
        //   value === 0
        //     ? {
        //       marginLeft: value ? 8 : 0,
        //       cursor: 'pointer',
        //       color: '#00B300',
        //     }
        //     : value === 1
        //       ? {
        //         marginLeft: value ? 8 : 0,
        //         cursor: 'pointer',
        //         color: '#ff0000',
        //       }
        //       : value === 2
        //         ? {
        //           marginLeft: value ? 8 : 0,
        //           cursor: 'pointer',
        //           color: '#ffbf00',
        //         }
        //         : {
        //           marginLeft: value ? 8 : 0,
        //           cursor: 'pointer',
        //           color: '#999999',
        //         },
        action: [
          {
            label: t('s.cadastro.pitstop.lubrificacao'),
            botao: Waves,
            edicao: 'lubrificacao',
            origem: 'L',
          },
        ],
      },
      // {
      //   id: 'statuscheckliberadoparaintegracao',
      //   label: t('s.operacao.checkliberadoparaintegracao.statuscheckliberadoparaintegracao'),
      // },
    ],
    [t]
  );

  React.useEffect(() => {
    handleGetPostosComboios();
  }, []);

  const handleGetPostosComboios = React.useCallback(async () => {
    const params = { pagesize: 9999, statusposto: 'L', pesquisalista: true };
    setLoad(true);
    try {
      const { data } = await api.get('postoscomboios', { params });
      setPostos(data.items);
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    } finally {
      setLoad(false);
    }
  }, []);

  React.useEffect(() => {
    if (params) {
      // if (!loading) {
      fetchData();
      // } else {
      //  console.log("aguardar")
      // }
    }
  }, [params]);

  function handleChangeStatusValue(event) {
    const { value } = event.target;
    setParams((prevState) => ({
      ...prevState,
      status: value,
    }));
  }

  function handleChangeIdVeiculoValue(event) {
    const { value } = event.target;
    setParams((prevState) => ({
      ...prevState,
      idveiculo: value,
    }));
  }

  function handleChangeCodigoAtendimentoValue(event) {
    const { value } = event.target;
    setParams((prevState) => ({
      ...prevState,
      codigoatendimento: value,
    }));
  }

  const handleChangeAutocomplete = React.useCallback(
    // idposto
    (value) => {
      if (!isNull(value)) {
        const { idposto } = value;
        setPosto(value);
        setParams((prevState) => ({
          ...prevState,
          idposto,
        }));
      } else {
        setPosto({
          codigonomeposto: '',
          codigoposto: '',
          idposto: '',
        });
        setParams((prevState) => ({
          ...prevState,
          idposto: '',
        }));
      }
    },
    []
  );

  const hancleSubmitConsulta = () => {
    // if (!loading) {
    fetchData();
    // } else {
    console.log('aguardar');
    // }
  };

  const handleOpenModal = (
    act,
    estaFechado,
    key,
    idveiculo,
    origem = null,
    idmovimentacao = null,
    idposto,
    statuslibintegraatendimentolubrificacao,
    statuslibintegraatendimentoabastecimento
  ) => {
    console.log(idposto);
    setJanelaAberta(true);
    const data = {
      idatendimento: key,
      idpostoGlobal,
      idturno,
      datahorainicialturno,
      datahorafinalturno,
      slapitstopposto,
      idveiculo,
      origem,
      idmovimentacao,
      idposto,
      statuslibintegraatendimentolubrificacao,
      statuslibintegraatendimentoabastecimento,
    };
    // setParametros(data);
    if (act === 'abastecimento') {
      abreTelaAbastecimento(data);
    } else if (act === 'lubrificacao') {
      abreTelaLubrificacao(data);
    }
  };

  const verificaDadosAbastecimento = React.useCallback(async (data) => {
    try {
      setJanelaAberta(true);
      setLoad(true);
      const resp = await api.get(
        `pitstop/abastecimento/${data.idatendimento}/${data.idposto}`
      );
      if (resp.data) {
        exibirAbastecimentoPitStopRef.current.handleToggleModal(data);
      } else if (resp.atendeuatendimentoabastecimento !== 'N') {
        // exibirSelecionaMovimentacaoPitStopRef.current.handleToggleModal(data);
        // exibirSelMovimentacaoPitStopRef.current.handleToggleModal(data);
      }
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    } finally {
      setLoad(false);
    }
  }, []);

  async function abreTelaAbastecimento(data) {
    verificaDadosAbastecimento(data);
  }

  const verificaDadosLubrificacao = React.useCallback(async (data) => {
    try {
      setJanelaAberta(true);
      setLoad(true);
      const resp = await api.get(
        `pitstop/lubrificacao/${data.idatendimento}/${data.idposto}`
      );
      if (resp.data) {
        exibirLubrificacaoPitStopRef.current.handleToggleModal(data);
      } else {
        // exibirSelecionaMovimentacaoPitStopRef.current.handleToggleModal(data);
        // exibirSelMovimentacaoPitStopRef.current.handleToggleModal(data);
      }
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    } finally {
      setLoad(false);
    }
  }, []);

  async function abreTelaLubrificacao(data) {
    verificaDadosLubrificacao(data);
  }

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await api.get(
        `pitstop/buscadadosatendimentomovimentacaomanualintegracao?${new URLSearchParams(
          params
        ).toString()}`
      );
      // atendimentos
      const l = data.atendimentos.map((atendimento) => ({
        ...atendimento,
      }));
      const list = l.map((row) => ({
        ...row,
        atendimentoFechado: row.dataliberacaoatendimento != null ? 'S' : 'N',
      }));
      setAtendimentos(list);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  }, [params]);

  useEffect(() => {
    // fetchData();
    const intervalId = setInterval(() => {
      fetchData();
    }, delayRefresh * (1000 * 60));
    return () => clearInterval(intervalId);
  }, [params]);

  return (
    <>
      {load && <LinearProgress />}
      <Grid
        container
        spacing={2}
        padding={2}
        alignItems="stretch"
        style={{ marginTop: '5px', marginRight: '5px' }}
      >
        <Grid item xs={12} sm={5}>
          <Autocomplete
            options={postos}
            value={posto}
            getOptionLabel={(posto) => `${posto.codigonomeposto}`}
            size="small"
            style={{ width: '100%' }}
            fullWidth
            onChange={(e, value) => handleChangeAutocomplete(value)}
            renderInput={(params) => (
              <TextField
                {...params}
                label={t('s.operacao.abastecimento.nomeposto')}
                variant="outlined"
                size="small"
                fullWidth
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <TextField
            label={t('s.cadastro.pitstop.codigoatendimento')}
            size="small"
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
            onChange={handleChangeCodigoAtendimentoValue}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <TextField
            label={t('s.operacao.abastecimento.idveiculo')}
            size="small"
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
            onChange={handleChangeIdVeiculoValue}
          />
        </Grid>

        {/* <Grid item xs={12} sm={2}>
          <TextField
            label={t('s.operacao.checkliberadoparaintegracao.statuscheckliberadoparaintegracao')}
            onChange={handleChangeStatusValue}
            //error={!!error}
            defaultValue={1}
            select
            //label={label}
            variant="outlined"
            fullWidth
            size="small"
            InputLabelProps={{
              shrink: true,
            }}
          //{...rest}
          >
            {options.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid> */}

        <Grid item xs={12} sm={1}>
          <Button
            loading
            onClick={() => hancleSubmitConsulta()}
            color="primary"
            variant="outlined"
          >
            Consultar
          </Button>
        </Grid>
      </Grid>

      <Tabela
        title={
          viewAtendimentos
            ? t('s.cadastro.pitstop.atendimentos')
            : viewAbastecimentos
            ? t('s.operacao.turno.abastecimentos')
            : t('s.cadastro.pitstop.lubrificacoes')
        }
        cells={headerAtendimento}
        data={atendimentos}
        height="80vh"
        size="small"
        onIconClick={handleOpenModal}
      />

      {/* atendimentos */}
      <AbastecimentoPitStop
        ref={exibirAbastecimentoPitStopRef}
        update={handleUpdate}
        close={handleClose}
        name="AbastecimentoPitStop"
      />

      {/* lubrificacao */}
      <LubrificacaoPitStop
        ref={exibirLubrificacaoPitStopRef}
        update={handleUpdate}
        close={handleClose}
        name="LubrificacaoPitStop"
      />
    </>
  );
}

export default Checkliberadoparaintegracao;
